import swedish from "./sv";
import english from "./en";

export const locales = {
  sv: swedish,
  en: english,
};

export const localeKeys = Object.keys(locales) as (keyof typeof locales)[];

export type LocaleType = keyof typeof locales;
